import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";
import { forms } from "../framework/forms";
import { application } from "../application/application";

function init() {
    setEvents();
}

function setEvents() {
    $(document).on("submit", "#courseFacPreEvaluationIndexForm", formSubmit);
    $(document).on("click", "#facPreEvaluationQuestionResponseYesNo10_Yes", Question10YesClick);
    $(document).on("click", "#facPreEvaluationQuestionResponseYesNo10_No", Question10NoClick);
}

function formSubmit(e) {
    e.preventDefault();
    const $form = $(this);
    $.validator.unobtrusive.parse("#courseFacPreEvaluationIndexForm");

    if ($form.valid()) {
        forms.showSpinner("Saving...", false);

        const params = {
            "contentType": dataaccess.contentType.APPLICATION_X_WWW_FORM_URLENCODED,
            "data": $form.serialize(),
            "url": $form.attr("action")
        };

        dataaccess.post(params)
            .fail(function (xhr, status, error) {
                if (xhr.status === 400 && xhr.responseText !== "") {
                    $("#errorMessage").html(xhr.responseText);
                }
            })
            .done(function (result) {
                const id = $("#modelId").val();
                const hash = $("#modelIdHash").val();
                window.location.href = application.baseUrl + "/coursefacpreevaluation/" + id + "/" + hash;

            })
            .always(function () {
                forms.hideSpinner();
            });
    } else {
        alert("Correct errors and try agaion");
    }
};

function Question10NoClick() {
    const question11Response = $("#evaluationQuestionExplanation11");
    question11Response.prop("placeholder","required");
    question11Response.prop("required", "required");
}
function Question10YesClick() {
    const question11Response = $("#evaluationQuestionExplanation11");
    question11Response.prop("placeholder", "optional");
    question11Response.prop("required","");
}
export const courseFacultyStudentEvaluation = {
    init
};